import React, { FC, PropsWithChildren } from 'react';
import { OptionLabelProps } from './types';
import { Field } from '@chakra-ui/react';
import { Typography } from '../Typography';
import { InfoButton } from '../InfoButton';
import { TooltipPlacement } from '../../hoc';

type OptionLabelPropsWithChildren = PropsWithChildren<OptionLabelProps>;

export const OptionLabel: FC<OptionLabelPropsWithChildren> = ({ label, helpText, tooltip, children }) => {
  return (
    <>
      <Typography as="span" textAlign="center" w="full" textStyle="p2">
        {label}
        {tooltip && (
          <InfoButton
            tooltip={{ content: tooltip.content, placement: TooltipPlacement.TOP }}
            m={-1}
            ms={1}
            verticalAlign={'baseline'}
          />
        )}
      </Typography>
      {helpText && (
        <Field.Root>
          <Field.HelperText>{helpText}</Field.HelperText>
        </Field.Root>
      )}
      {children}
    </>
  );
};

OptionLabel.displayName = 'OptionLabel';
